import { Link, useNavigate } from 'react-router-dom';
import { FC } from 'react';
import { User } from '../interfaces/user';

interface NavbarProps {
  isLoggedIn: boolean;
  onLogout: () => void;
  user: User | null;
}

const Navbar: FC<NavbarProps> = ({ isLoggedIn, onLogout, user }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          Monitoring Tool
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/systems">
                Systems
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/users">
                Users
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/subscriptions">
                Subscriptions
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/incidents">
                Incidents
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/alerts">
                Alerts
              </Link>
            </li>
          </ul>

          {isLoggedIn && (
            <>
              <div className="d-flex p-3">{user?.name}</div>
              <div className="d-flex">
                <button className="btn btn-danger" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
